import { loadWidget } from '@sitevision/react';
import React from 'react';
import ReactDOM from 'react-dom';
import YourBenefits from './templates/organisms/your-benefits';

loadWidget('.plf-your-benefits-area', yourBenefitsWidget => {
    const action = yourBenefitsWidget.dataset.action;
    ReactDOM.render(<YourBenefits action={action} />, yourBenefitsWidget);
});
